import React,{useEffect,useState} from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import UserMasterFooter from './UserCommonComponent/UserMasterFooter';
import UserMasterHeader from './UserCommonComponent/UserMasterHeader';
import '../../src/UserComponents/UserComponent.css'
import Form from 'react-bootstrap/Form';
import {useNavigate} from 'react-router-dom';
import InputGroup from 'react-bootstrap/InputGroup';
import Logo from '../assets/Mainlogo.jpg';
import Logo2 from '../assets/logo2.png';
import Nav from 'react-bootstrap/Nav';
import HeaderPage from '../NewLoginPage/HeaderPage';
import FooterUser from '../NewLoginPage/FooterUser';



const Dashboard = () => {

   // Scroll to the top when component is mounted
   useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate=useNavigate()
  const [isChecked, setIsChecked] = useState(false);


  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleNextClick = () => {
    if (isChecked) {      
      // navigate('/user/regForm');      
      navigate('/RegFirstPage');      
    } 
  }

  useEffect(() =>{
    let newStatus=sessionStorage.getItem("status");
    if(newStatus){
      if(newStatus === 3){
        navigate('/userDashboard')
      }
      else if(newStatus == 4){
        navigate('/user/regForm')
      }
      else if (newStatus ==  5){
        navigate('/payment')
      }
      else{
        // alert("hgvcgjasvbc")
      }
    }
    
  },[])

  {/* --------------footer css------------------ */}
  
  const footerStyle = {
    backgroundColor:"#e9e0e3",
    boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
    padding:"8px",
    textAlign:"center",
    color:"#000",
    fontSize:"12px",
    position:"fixed",
    bottom:0,
    width:"100%",
    letterSpacing:"1px",
  }

  const logoutFun = () => {
    sessionStorage.removeItem("userdata");
    sessionStorage.clear()
    navigate("/");    
  }
  
  return (
    <div className='p-0'>
      
     <HeaderPage/>

           {/* --------------Main------------------ */}
        <div className='pb-5'>
          <Row className='py-4 mb-3' style={{display:"flex",justifyContent:"center"}}>
            <Col sm={12} md={8} className='p-4 mb-2 rounded shadow mx-3' style={{backgroundColor:"rgb(233, 224, 227)"}}>
            <h6><b style={{color:"red"}}>IMP Notice:</b></h6><br/>
              <p>1) Last Date to Submit Form is 05/10/2024</p>

              <p>2) Registration Charges Rs 800/-</p>

              <p>3) The candidate should not register his name multiple times, multiple entries will not be entertained</p>

              <p>4) After making Payment kindly whatsapp the payment details to 7022691008 and get the receipt of the same by whats app</p>

              <p>5) Kindly type your details correctly as the same details that you typed will be printed in the Booklet without any correction from the organizer-  Manikbag Digambar Jain Boarding, Belagavi.</p>

              <p>6) Organisers, Manikbag Digambar Jain Boarding, Belgavi will not be responsible for any mistakes in data typed by candidate</p>

              <p>7) Details of the persons whose payment is received & confirmed by Manikbag Digambar Jain Boarding will only be printed in the Book.</p>

              <p>8) Before submitting the form kindly Re-check your details , as the same data will be printed in the booklet.</p>

              <p>9) For any Details contact  7022691008 or email at mdjbbelgavi@gmail.com </p>

              <p>10) The organisers are not responsible for any Mis-Information provided by any candidate.</p>

              <p>11) Manikbag Digambar Jain Boarding shall not bear the responsibility for the authenticity of data which going to be printed in the booklet.</p>

              <p>12) Kindly make Payment of Registration fees first before filling the Registration Form.</p>

              <p>13) SUBJECT TO BELAGAVI JURISDICTION</p>

              <p>14) For any queries, clarification  and ADVERTISEMENTS in BOOKLET contact Kuntinath Kalamani 9480448108</p>

              <p>15) After submitting ON-LINE FORM if there are any Corrections kindly Contact  7022691008 between 11 am to 5 pm on working days.</p>

              <p>16) PHOTO uploaded should be of HIGH RESOLUTION.</p>

              <p>17) On the day of event along with the candidate 2 persons are allowed to attend. Breakfast & Lunch arrangements are made by the organisers at the venue.</p>
            
              
            </Col>
          </Row>

          <Row className='m-0' style={{display:"flex",justifyContent:"center",}}>
            <Col sm={8}>
              <input className=''
              type="checkbox"
              name="check"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <label><p className=''><b style={{fontSize:"14px",paddingLeft:"10px"}}>I have read the above instructions carefully.</b></p></label>
            </Col>
          </Row>
          <Row className='m-0' style={{display:"flex",justifyContent:"center",}}>
              <Col sm={8}>
                <button   className='rounded px-3 py-1 mb-4 fs-5 ' 
                onClick={handleNextClick} 
                disabled={!isChecked}
                >
                  Register
                </button>
              </Col>
          </Row>
        </div>
        
      {/* --------------footer------------------ */}
        <FooterUser className="m-0" />
      
    </div> 
  )
}


export default Dashboard